<template>
	<div :class="classNames">
		<div :class="classNames+ '_search'">
			<div :class="classNames+ '_search_con'">
				<div :class="classNames+ '_search_con_item'" style="width:260px;">
					<span :class="classNames+ '_search_con_item_title'">订单编号</span>
					<el-input placeholder="" v-model="searchObj.order_id"></el-input>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">申请时间</span>
					<!-- <el-date-picker v-model="times" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm">
    				</el-date-picker> -->
					<el-date-picker v-model="searchObj.apply_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
					</el-date-picker>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">手机号</span>
					<el-input placeholder="请输入授权手机号" v-model="searchObj.tel_number"></el-input>
				</div>
				<template v-if="openlist">
					<div :class="classNames+ '_search_con_item'">
						<span :class="classNames+ '_search_con_item_title'">退款原因</span>
						<el-select v-model="searchObj.refund_reason" @change="changeReason">
							<el-option v-for="(item, index) in reasonList" :label="item.reason_text" :value="item.reason" :key="index"></el-option>
						</el-select>
					</div>
					<div :class="classNames+ '_search_con_item'">
						<span :class="classNames+ '_search_con_item_title'">退款状态</span>
						<el-select v-model="searchObj.status" @change="changeReason">
							<el-option v-for="(item, index) in stateList" :label="item.label" :value="item.value" :key="index"></el-option>
						</el-select>
					</div>
				</template>

				<div :class="[classNames+ '_search_con_item', classNames+ '_oprtation']">
					<el-button type="primary" @click="searchRes">查询</el-button>
					<el-button type="primary" @click="exportExcel">导出</el-button>
					<el-button style="border:none;" v-if="!openlist" icon="el-icon-arrow-down" @click="openlist=true">高级筛选</el-button>
					<el-button style="border:none;" v-if="openlist" icon="el-icon-arrow-up" @click="openlist=false">收起</el-button>
					<span class="total_sums">共{{orderInfo.total}}条</span>
				</div>
			</div>
		</div>
		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-table :data="orderInfo.list" :header-cell-style="{background: '#F5F7FA',color:'#454D53'}" :cell-style="cellStyle">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<el-table-column :label="item.label" :prop="item.prop" v-for="(item, index) in headerList"
						:type="item.prop" :key="index" :width="item.width" :align="item.align" :show-overflow-tooltip="item.showOverflowTooltip">
						<template slot-scope="scope">
							<div v-if="item.prop === 'product_title'">
								<div :class="classNames+'_empty'"></div>
								<div :class="classNames+'_item'">
									<span style="min-width:220px">订单编号：{{scope.row.order_id}}</span>
									<span>支付时间：{{ scope.row.order_pay_time || '--' }}</span>
									<span>申请时间：{{ scope.row.create_time || '--' }}</span>
									<span>购买手机号：{{ scope.row.details_tel_number || '--' }}</span>
								</div>
								<div :class="classNames+'_class_title_box'">
									<el-image class="title-cover" :src="scope.row.product_img" fit="fit"></el-image>
									<div class="title-text">{{scope.row[item.prop]}}</div>
								</div>
							</div>
							<div v-else-if="item.prop === 'type'">
								<div class="one-line-hidden" style="font-weight: 800;">{{  scope.row.type }}</div>
								<div class="one-line-hidden">{{ scope.row.reason_text }}</div>
							</div>
							<div v-else-if="item.prop === 'refund_amount'">
								<div style="font-weight: 800;">
									¥{{ scope.row.refund_amount }} / {{ scope.row.scount }}件
								</div>
								<div>
									实付款：¥{{ scope.row.order_price }}
								</div>
							</div>
							<div v-else-if="item.prop === 'status'">
								<el-tooltip class="item" effect="dark" :content="getStatusVal(scope.row.status, 'value', 'label')" placement="top">
									<div :class="['buy']">
										{{ getStatusVal(scope.row.status, 'value', 'label') }}
									</div>
								</el-tooltip>
								<div style="color:#ccc;font-size:12px;" v-if="getStatusVal(scope.row.status, 'value', 'showRest')">
									剩余{{ timeTransform(scope.row.countdown) }}
								</div>
							</div>
							<span v-else>{{scope.row[item.prop]}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100" fixed="right">
						<template slot-scope="scope">
							<div :class="classNames+'_operation_title_box'">
								<!-- <span @click="opearte(scope.row, 1)" :class="classNames+'_operation_title'" v-if="getStatusVal(scope.row.status, 'value', 'showAgreeBtn')">同意</span> -->
								<!-- <span @click="opearte(scope.row, 2)" :class="classNames+'_operation_title'" v-if="getStatusVal(scope.row.status, 'value', 'showRejectBtn')">拒绝</span> -->
								<!-- <span @click="opearte(scope.row, 3)" :class="classNames+'_operation_title'" v-if="true">协商</span> -->
								<span @click="opearte(scope.row, 4)" :class="classNames+'_operation_title'" v-if="true">详情</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="orderInfo.total" ref="pagination" v-if="showPagination" v-model="searchObj.page"></Pagination>
		</div>
		<!-- 详情弹窗 -->
		<refundDrawer v-model="drawerFlag" :detailObj="drawerDetail" :showFlag="true"></refundDrawer>
		<!-- 拒绝弹窗 -->
		<rejectPop v-model="rejectObj.showPop" @sureReject="sureReject" :detailObj="drawerDetail" title="拒绝退款"></rejectPop>
		<!-- 协商弹窗 -->
		<consultPop v-model="consultObj.showPop" title="协商退款"></consultPop>
	</div>
</template>

<script>
	import { timeTransform, findBtnAuth } from '@/utils/utils.js'
	import rejectPop from './components/rejectPop.vue'
	import consultPop from './components/consultPop.vue'
	import {
		data
	} from './data.js'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	import refundDrawer from './components/refundDrawer.vue'
	import staticPathTitle from '@/utils/baseUrl.js'
	export default {
		name: 'Order',
		mixins: [data],
		data() {
			return {
				classNames: 'refund',
				times: [],
				searchObj: {
					page:1,
					page_size:10,
					order_id: '', // 订单号
					apply_date: '', // 申请时间 YYYY-MM-DD格式
					tel_number: '', // 手机号
					refund_reason: '', // 退款原因
					status: '', // 退款状态
				},
				noDataName: 'empty',
				drawerFlag: false, // 展示详情弹窗
				drawerDetail: {},// 详情信息
				openlist:true,
				orderInfo: {
					list: [],
					total: 0
				},
				rejectObj: {
					showPop: false,
					detail: {}
				}, // 拒绝弹窗相关
				consultObj: {
					showPop: false,
					detail: {}
				}, // 协商弹窗相关
				operaBtnAuth:{
					detail: false,
					export: false,
				},
			}
		},
		created() {
			this.getOrderInfos(true)
		},
		components: {
			Pagination,
			refundDrawer,
			rejectPop,
			consultPop
		},
		computed: {
			...mapState(['breadCrumbList']),
			...mapState("permission", ["menuList"]),
			...mapState('message',['waitCountObj']),
			cellStyle() {
				return {
					'padding': '54px 0 12px 0'
				}
			},
			// 显示页码
			showPagination(){
				if(this.orderInfo.total > 0){
					return true
				}else{
					return false
				}
			}
		},
		watch: {
			menuList: {
			    deep: true,
			    immediate: true,
			    handler(newVal, oldVal) {
			        if(newVal.length > 0) {
						// this.getUserAuthBtn()
			        }
			    }
			},
		},
		methods: {
			...mapActions('export', ['createExportAPI']),
			...mapActions('withdrawal', ['orderRefund']),
			...mapActions('sphApis', ['sureRefundAPI']),
			timeTransform,
			// 确认拒绝退款
			sureReject(){
				this.getOrderInfos()
			},
			// 修改原因
			changeReason(val){
				// console.log('changeReason-val:',val)
			},
			// 获取退款状态列表某值
			getStatusVal(val, listVal, res){ // val 当前值, listVal 与列表对应的value, res 返回对应value
				return this.stateList.find(item=>item[listVal]==val)[res]
			},
			// 改变页码
			changeSize(size) {
				this.searchObj.page = size
				this.getOrderInfos()
			},
			// changeTime(value, a, b) {
			// 	console.log(this.times, 'pppp')
			// 	this.searchObj.start_time = this.times && this.times.length ? this.times[0] : ''
			// 	this.searchObj.end_time = this.times && this.times.length ? this.times[1] : ''
			// },
			// 获取列表信息
			async getOrderInfos(flag) {
				if(flag) {
					this.searchObj.page = 1
				}
				let res = await this.orderRefund(this.searchObj)
				this.orderInfo = {
					list: res.list,
					total: res.page_info.total_count
				}
			},
			searchRes() {
				this.noDataName = 'noData'
				this.getOrderInfos(true)
			},
			exportExcel() {
				const searchObj = {}
				for (const key in this.searchObj) {
					if (this.searchObj[key]) {
						searchObj[key] = this.searchObj[key]					
					}
				}
				searchObj.comeFrom = staticPathTitle[this.staticPath].value
				this.$confirm('5分钟内仅可导出一次,导出后可在导出记录中查看导出进度,导出成功的数据请在24小时内下载', '导出提示', {
					distinguishCancelAndClose: true,
					confirmButtonText: '导出',
					cancelButtonText: '取消',
					customClass: ''
				})
				.then(async() => {
					await this.createExportAPI({
						type: 2, // 1用户订单 2退款订单 3申诉订单 4发货订单 5线索订单
						search_params: {
							...searchObj,
							excel: 1
						}
					})
					this.$router.push({
						path:  this.staticPath + "exportHistory"
					})
				})
			},
			// 操作
			async opearte(row, type) {
				let that = this
				if(type == 1 ){ // 同意
					let {refund_amount,after_sale_order_id} = row
					this.$confirm(`确认退款后，退款金额¥${refund_amount}将直接退回买家支付账户内`, '同意退款?', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						center: true
					}).then(async () => {
						await that.sureRefundAPI({after_sale_order_id})
						this.$message({
							type: 'success',
							message: '退款成功!'
						});
						this.getOrderInfos()
					}).catch(() => {});
				}
				if(type == 2){ // 拒绝
					this.drawerDetail = row
					this.rejectObj.showPop = true
				}
				if(type == 3){ // 协商
					this.consultObj.showPop = true
				}
				if(type == 4){ // 详情
					// console.log('row:',row)
					this.drawerDetail = {
						...row,
						cus_add_status_text: this.getStatusVal(row.status, 'value', 'label') // 退款状态文字
					}
					this.drawerFlag = true
				}
			},
			getUserAuthBtn(){
				const detailName = 'btn.refund.detail'
				const detailBtn = findBtnAuth(this.menuList, item => item.route_name == detailName)
				if(!!detailBtn){
					this.operaBtnAuth.detail = true
				}
				
				const exportName = 'btn.refund.export'
				const exportBtn = findBtnAuth(this.menuList, item => item.route_name == exportName)
				if(!!exportBtn){
					this.operaBtnAuth.export = true
				}
			}
		}
	}
</script>
<style lang="less" scoped>
	@classNames: refund;
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.tr-hide {
			display: none;
		}
		// /deep/.el-tabs__item {
		// 	position: relative;
		// 	&.is-active::after{
		// 		content: "";
		// 		border:4px solid red;
		// 		border-radius: 4px;
		// 		position: absolute;
		// 	}
		// }
		.@{classNames}_operation_title_box {
			display: flex;
			flex-direction: column;
			.@{classNames}_operation_title {
				text-align: left;
				// display: inline-block;
				color: #1989FA;
				font-size: 14px;
				cursor: pointer;
				// &:not(:last-child) {
				// 	margin-right: 12px;
				// }
			}
		}
		
	}
	.@{classNames}_oprtation {
		flex: 1 0 auto;
		display: flex;
		justify-content:flex-start;
		position: relative;
		.el-button--primary {
			margin:0 6px;
		}
		.total_sums{
			position: absolute;
			top:50%;
			transform: translateX(-50%);
			right: 0;
			font-weight: normal;
			color: #606266;
		}
	}

	.@{classNames}_detailed {
		padding: 20px 24px;
		width: 400px;
		box-sizing: border-box;
		.el-dialog__body {
			padding: 0;
		}
		.el-dialog__header {
			padding: 0 0 13px 0;
			.el-dialog__title {
				font-size: 16px;
				font-weight: 500;
				color: #485059;
			}
		}
	}
	.@{classNames}_con_table {
		.@{classNames}_empty {
			position: absolute;
			top: 0px;
			left: 0;
			width: 1000px;
			height:10px;
			background: #fff;
			z-index: 100;
		}
		.@{classNames}_item {
			position: absolute;
			top: 10px;
			left: 0;
			width: 1000px;
			padding: 0 12px;
			height: 32px;
			background: #F5F7FA;
			color: #888a95;
    		font-size: 12px;
			line-height: 32px;
			display: flex;
			justify-content: flex-start;
			z-index: 1000;
			span {
				&:not(:first-child) {
					margin-left: 12px;
				}
			}
		}
		.buy {
			min-width: 66px;
			max-width: 110px;
			height: 24px;
			border-radius: 12px;
			border: 1px solid #333;
			font-size: 14px;
			color: #333;
			line-height: 24px;
			text-align: center;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			padding: 0 6px;
			cursor: pointer;
		}
		.one-line-hidden{
			white-space: nowrap;
			overflow: hidden;
			width: 100%;
			text-overflow: ellipsis;
		}
	}
</style>
<style lang='less' scoped>
	@classNames: refund;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
		.@{classNames}_statistics {
			flex-shrink: 0;
			padding: 20px 0;
			box-sizing: border-box;
			span {
				font-size: 16px;
				font-weight: 600;
				color: #485059;
				line-height: 16px;
				&:last-child {
					margin-left: 60px;
				}
			}
		}
		.@{classNames}_search {
			display: flex;
			flex-shrink: 0;
			padding-bottom: 20px;
			box-sizing: border-box;
			border-bottom: 1px solid #F8F8FB;
			flex-wrap: wrap;
			justify-content: space-between;
			.@{classNames}_search_con {
				display: flex;
				flex-wrap: wrap;
				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;
					margin-bottom: 12px;
					
					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}

		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
			.@{classNames}_class_title_box{
				width: 100%;
				display: flex;
				align-items: center;
				.title-cover{
					width: 110px; 
					height: 82px;
					border-radius:5px;
				}
				.title-text{
					flex: 1;
					margin-left: 5px;
				}
			}
			.@{classNames}_con_table {
				.@{classNames}_empty {
					position: absolute;
					top: 0px;
					left: 0;
					width: 700px;
					height:10px;
					background: transparent;
					z-index: 100;
				}
				.@{classNames}_item {
					position: absolute;
					top: 10px;
					left: 0;
					width: 1000px;
					padding: 0 12px;
					height: 32px;
					background: transparent;
					// background: #F5F7FA;
					color: #888a95;
					font-size: 12px;
					line-height: 32px;
					display: flex;
					justify-content: flex-start;
					z-index: 1000;
					span {
						&:not(:first-child) {
							margin-left: 12px;
						}
					}
				}
			}
		}
	}
	
	/deep/.refund-dialog {
		.el-dialog__header {
			padding:16px;
			.el-dialog__headerbtn {
				top: 16px;
			}
		}
		.el-dialog__body {
			padding:0 16px 16px;
		}
		.el-dialog__footer {
			padding: 0 16px 16px;
		}
	}
	/deep/ .el-table__row {
		>td {
			position: relative;
			&::after{
				content: '';
				position: absolute;
				top: 10px;
				left: 0;
				width: 100%;
				height: 32px;
				background: #f5f7fa;
			}
		}
	}
</style>
